import { Component, OnInit } from '@angular/core';
import { DictionaryItem, DictionaryResponse } from 'voxloud-types/dist/models/ai-assistant/index';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiAssistantService } from 'src/app/domains/internal-facilities/ai-assistant/services/ai-assistant.service';
import { CreateDictionaryPopupComponent } from '../create-dictionary-popup/create-dictionary-popup.component';
import { UpdateDictionaryPopupComponent } from '../update-dictionary-popup/update-dictionary-popup.component';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

const PAGE_SIZE = 30;

@Component({
  selector: 'gdp-ai-assistant-main',
  templateUrl: './ai-assistant-main.component.html',
  styleUrls: ['./ai-assistant-main.component.scss']
})
export class AiAssistantComponent implements OnInit {
  public loading: boolean = false;
  public dictionary: DictionaryItem[];
  public searchKey: string = '';
  // Pagination
  public pageSize: number = PAGE_SIZE;
  public pagination = {
    page: 0,
    empty: true,
    totalPages: 0
  };

  constructor(
    private aiAssistantService: AiAssistantService,
    private modalService: NgbModal,
    private notifications: NotificationService
  ) {}

  ngOnInit(): void {
    this.getDictionary();
  }

  private getDictionary(): void {
    this.loading = true;
    this.aiAssistantService.getDictionary(this.pagination.page, this.pageSize, this.searchKey).subscribe((res: DictionaryResponse) => {
      this.dictionary = res.content;
      this.dictionary.length !== 0
        ? this.pagination.totalPages = res.total_pages
        : this.pagination.totalPages = 1;
      this.loading = false;
    }, () => {
      this.dictionary = [];
      this.pagination.totalPages = 1;
      this.pagination.page = 0;
      this.loading = false;
    });
  }

  public selectPageSize(event: number): void {
    this.pageSize = event;
    this.pagination.page = 0;
    this.getDictionary();
  }

  public changeCurrentPage(event: number): void {
    this.pagination = {
      page: event,
      empty: this.dictionary.length === 0,
      totalPages: this.pagination.totalPages
    }
    this.getDictionary();
  }

  public addDictionary(): void {
    const modal = this.modalService.open(CreateDictionaryPopupComponent, {
      size: 'lg'
    });
    modal.componentInstance.emitCreatedDictionary.subscribe((res: DictionaryItem) => {
      this.notifications.success('internal-facilities.ai-assistant.create-popup.success');
      this.getDictionary();
    });
  }

  public searchDictionary(): void {
    this.getDictionary();
  }

  public updateDictionary(dictionary: DictionaryItem): void {
    const modal = this.modalService.open(UpdateDictionaryPopupComponent, {
      size: 'lg'
    });
    modal.componentInstance.dictionaryItem = dictionary;
    modal.componentInstance.emitUpdatedDictionary.subscribe((res: DictionaryItem) => {
      this.notifications.success('internal-facilities.ai-assistant.update-popup.success');
      this.getDictionary();
    });
  }

  public deleteDictionary(): void {
    this.notifications.success('internal-facilities.ai-assistant.success-delete');
  }
}
